@if (vm$ | async; as vm) {
  <span>{{ vm.amount | currencyformatByCurrencyCode: vm.currencyCode : false }}</span>
}
